const defaults = {
  cartDrawer: '.js-ajax-cart-drawer', // classname
  cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
  cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
  cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
  cartOverlay: '.js-ajax-cart-overlay', // classname
  cartCounter: '.js-ajax-cart-counter', // classname
  addToCart: '.js-ajax-add-to-cart', // classname
  removeFromCart: '.js-ajax-remove-from-cart', //classname
  removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
  cartNoteToggle: '.toggle-cart-note',
  cartNote: '.Cart__OffscreenNoteContainer',
  cartNoteSubmit: '.save-cart-note-button',
  checkoutButton: '.js-ajax-checkout-button',
};

const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const cartNote = document.querySelector(defaults.cartNote);
const cartNoteToggle = document.querySelector(defaults.cartNoteToggle);
const cartNoteSubmit = document.querySelector(defaults.cartNoteSubmit);
const htmlSelector = document.documentElement;

for (let i = 0; i < addToCart.length; i++) {
  addToCart[i].addEventListener('click', function(event) {
    event.preventDefault(); 
    const formID = $(this).parents('form').attr('id');
    addProductToCart(formID);
    setTimeout(function(){
      openCartDrawer();
      openCartOverlay();
    }, 2000);
  });

}

function addProductToCart(formID) {
  var form = $('#' + formID).serialize();
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: $('#' + formID)
    .serialize(),

    success: function(result){
      $('#' + formID).find('.drawer-btn.product-form__submit').text('Added');
      setTimeout(function(){
        $('#' + formID).find('.drawer-btn.product-form__submit').text('Add +');
      }, 2000);
      
      addToCartOk(result);
      upsellplusapp.init_drawer_offer();
    }
  });
}

var first_product_clicked = false;
var second_product_clicked = false;
var FreeProductQuantity =  $('.free-product .quantity__input').val();
if(FreeProductQuantity >= "2"){
  $('.ajax-cart-drawer__upsell').addClass('upsell-products');
  $('body').addClass('disable-sample');
}

$('.free-product-slider .product-form__submit.drawer-btn').click(function(){
  console.log('true Button')
  $('.free-product-slider .product-form__submit.drawer-btn').prop('disabled', true)
});
      
function fetchCart() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      onCartUpdate(cart);
      if (cart.item_count === 0) {
        cartDrawerContent.innerHTML = '';
        cartDrawerContent.innerHTML = '<p>Cart is empty</p><div class="continue-shopping-btn"><a href="/collections/all">Continue Shopping</a></div>';
        checkoutButton.classList.add('is-hidden');        
        $('.continue-shopping-btn a').click(function(e){
          // e.preventDefault();
          closeCartDrawer();
          closeCartOverlay();
        });
      } else {
        renderCart(cart);
        checkoutButton.classList.remove('is-hidden'); 
      }
      
      $('.free-product').each(function(){
        $(this).find('.ajax-cart-item__quantity input').prop('readonly', true);
      });

      $('.free-product-slider .product-form__submit.drawer-btn').prop('disabled', false)

      var cartsubTotal = $('.sub-total-footer .ajax-cart-drawer__cart-total').text();
      var unitTotal = cartsubTotal.replace(/[^\d.]/g, '');
      var interestFee = unitTotal / 4;
      $('.afterpay-widget p b').text('$'+interestFee.toFixed(2));
      
      let first_productPrice = $('.free-product-price.first_product').text();
      let second_productPrice = $('.free-product-price.second_product').text();
      let cartTotal = cart.total_price;
      let first_freeLength = $('.ajax-cart-item__single.gift-product.first_product').length;
      let second_freeLength = $('.ajax-cart-item__single.gift-product.second_product').length;

      var first_giftPrice = ''
      if(first_freeLength >= 1){
        first_giftPrice = cartTotal - first_productPrice;
      }else{
        first_giftPrice = cart.total_price;
      }

      var second_giftPrice = ''
      if(second_freeLength >= 1){
        second_giftPrice = cartTotal - second_productPrice;
      }else{
        second_giftPrice = cart.total_price;
      }
      
      if(cart.total_price >= 5000){
        $('body').removeClass('disable-sample');
      }else{
        $('body').addClass('disable-sample');
      }
      
      if(cart.total_price < 5000){
        $('.free-product').each(function(){
          var remove__btn = $(this).find('.js-ajax-remove-from-cart');
          var variantId = $(remove__btn).data("vid");
          changeItem(variantId,0);
        });
      }

      if(first_giftPrice <= 12500){
        $('.gift-product.first_product').each(function(){
          var remove__btn = $(this).find('.js-ajax-remove-from-cart');
          var variantId = $(remove__btn).data("vid");
          changeItem(variantId,0);
          first_product_clicked = false;
        });
      }
      
      if(first_giftPrice > 12500){
        if(first_freeLength < 1){
        var InputValue = $('.gift-product.first_product .quantity__input').val();
        if(!first_product_clicked && ( InputValue == 1 || typeof InputValue == 'undefined') ){
          $('.first_product.free_gift_product button').click();    
        }
        first_product_clicked = true;
        }
      }
      
      if(second_giftPrice <= 250000){
        $('.gift-product.second_product').each(function(){
          var remove__btn = $(this).find('.js-ajax-remove-from-cart');
          var variantId = $(remove__btn).data("vid");
          changeItem(variantId,0);
          second_product_clicked = false;
        });
      }
      
      if(second_giftPrice > 250000){
        if(second_freeLength < 1){
        var InputValue = $('.gift-product.second_product .quantity__input').val();
        if(!second_product_clicked && ( InputValue == 1 || typeof InputValue == 'undefined') ){
          $('.second_product.free_gift_product button').click();    
        }
        second_product_clicked = true;
        }
      }
      
      if(cart.total_price >= 5000){
        $('.ajax-cart-drawer__upsell').removeClass('upsell-products');
      }else{
        $('.ajax-cart-drawer__upsell').addClass('upsell-products');  
      }

      var ItemCount = $('.free-product').length;      
      if(ItemCount == "2"){
        $('.ajax-cart-drawer__upsell').addClass('upsell-products');
        $('body').addClass('disable-sample');
        $('.free-product').each(function(){
          $(this).find('.quantity__button').css('pointer-events','none')
        });
      }
      
      var FreeProductQuantity =  $('.free-product .quantity__input').val();
      if(FreeProductQuantity >= "2"){
        $('.ajax-cart-drawer__upsell').addClass('upsell-products');
        $('body').addClass('disable-sample');
        if(FreeProductQuantity >= "2"){
        $('.free-product').each(function(){
          $(this).find('.quantity__button[name="plus"]').css('pointer-events','none')
        });
        }
      }

      let btn_clicked = false;
      var count = 0
      $('.ajax-cart-item__single').each(function(){
        var ProductTitle = $(this).data('product-id');
        var ProductVariant = $(this).data('variant-id');
        if(ProductTitle == 7202857943134 && ProductVariant == 41144681070686){
          count++;
        }
      });
      setTimeout(function() {
        if(count == 0){
          $('.get-product').each(function(){
            var remove_btn = $(this).find('.js-ajax-remove-from-cart');
            var variant_Id = $(remove_btn).data("vid");
            changeItem(variant_Id,0);
            btn_clicked = false;
          });
          
        }else{
          var ProductInputValue = $('.get-product .quantity__input').val();
          if(!btn_clicked && ( ProductInputValue < 1 || typeof ProductInputValue == 'undefined') ){
            $('.free_automatically_product button').click();
          }
          btn_clicked = true;
        }
      }, 1000);
      
    },
  });
}

function changeItem(id, callback) {
  const quantity = 0;
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'id=' + id + '&quantity=' + quantity,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {    
        onCartUpdate(cart);
        fetchCart();
      }
    },
  });
}


function updateItem(line, quantity, callback) {
  //const quantity = 0;
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {        
        onCartUpdate(cart);        
        fetchCart();
      }
     
    },
  });
}

function onCartUpdate(cart) {
  
  if(cart.item_count == 0){
    $('.js-ajax-cart-drawer-trigger .cart-count-bubble').remove();
    $('.ajax-cart-drawer').addClass('empty-cart');
    var threshold = $('.Cart_ShippingNotice').data('threshold');
    if(threshold != undefined){
      if(cart.total_price >= threshold){
        $('.Cart_ShippingNotice .Drawer__Container').html('<span>Congrats! You get free shipping.</span>');
      }else{
        var remain = threshold - cart.total_price;
        $('.Cart_ShippingNotice .Drawer__Container').html('<span> Free Shipping for all orders above '+Shopify.formatMoney(remain)+'</span>');
      }
    }
  }else{
    if($('.js-ajax-cart-drawer-trigger .cart-count-bubble').length > 0){
      $('.js-ajax-cart-counter').innerHTML = Number(cart.item_count);
      $('.ajax-cart-drawer').removeClass('empty-cart');
    }else{
      $('.js-ajax-cart-drawer-trigger').append('<div class="cart-count-bubble"><span aria-hidden="true" class="js-ajax-cart-counter">'+cart.item_count+'</span><span class="visually-hidden">'+cart.item_count+' item</span></div>');

    }
  } 
}

function addToCartOk(product) {
  openCartDrawer();
  fetchCart();
}


function removeProductFromCart(cart) {
  fetchCart();
}


function renderCart(cart) {
  var threshold = $('.Cart_ShippingNotice').data('threshold');
  if(threshold != undefined){
    if(cart.total_price >= threshold){
      $('.Cart_ShippingNotice .Drawer__Container').html('<span> Congrats! You get 2 free samples.</span>');
    }else{
      var remain = threshold - cart.total_price;
      $('.Cart_ShippingNotice .Drawer__Container').html('<span>'+Shopify.formatMoney(remain)+' away from 2 free samples</span>');
    }
  }

  clearCartDrawer();

  if(cart.items.length > 0){
    $('.ajax-cart-drawer__cart-total').html(Shopify.formatMoney(cart.total_price));
    $('.ajax-cart-drawer').removeClass('empty-cart');

    if(cartCounter == undefined){
      $('.js-ajax-cart-drawer-trigger').append('<div class="cart-count-bubble"><span aria-hidden="true" class="js-ajax-cart-counter">'+cart.item_count+'</span></div>')
    }
    $('.js-ajax-cart-drawer-trigger').append('<div class="cart-count-bubble"><span aria-hidden="true" class="js-ajax-cart-counter">'+cart.item_count+'</span></div>')
  }else{
  }

  count = 0;
  cart.items.forEach(function(item, index) {
    const productTitle = '<div class="ajax-cart-item__title">' + item.product_title + '</div>';
    
    var productProperty = ''+item.properties["line-item"]+''; 

    console.log("ID: " + item.handle);

    if (item.handle == 'free-mini-ultra-peptide-cream') {
      productProperty = productProperty + ' first_product';
    } else if (item.handle == 'free-mystery-bag-2') {
      productProperty = productProperty + ' second_product';
    }

    if (item.selling_plan_allocation != null) {
      var productSellingPlan = '<div class="ajax-cart-item_selling_plan">'+item.selling_plan_allocation.selling_plan.name+'</div>';   
    }else{
      var productSellingPlan = '<div class="ajax-cart-item_selling_plan"></div>';   
    }
    
    if ( item.final_price > 0) {
      var variantTitle = '<div class="ajax-cart-item_variant__title">' + item.variant_title + '</div>';
    }else{
      var variantTitle = '<div class="ajax-cart-item_variant__title"></div>';
    }
    const productImage = '<img class="ajax-cart-item__image" src="' + item.image + '" >';
    const productPrice = '<div class="ajax-cart-item__price">' + Shopify.formatMoney(item.line_price) + '</div>';    
    ///const productQuantity = '<div class="ajax-cart-item__quantity">' + item.quantity + '</div>';
    //     const productQuantity = '<div class="ajax-cart-item__quantity"><quantity-input class="quantity" data-line="' + Number(index + 1) + '">'+
    //       '<button class="quantity__button no-js-hidden js-ajax-cart-minus" name="minus" type="button" aria-label="Reduce quantity">-</button>'+
    //       '<input class="quantity__input js-ajax-item__quantity" type="number" name="updates[]" id="Quantity-'+index+'" value="'+item.quantity+'" form="ajax-cart-item__quantity'+index+'">'+
    //       '<button class="quantity__button no-js-hidden js-ajax-cart-plus" name="plus" type="button" aria-label="Increase quantity">+</button></div>'+
    //       '</quantity-input>';

    
    // if ( typeof item.properties['line-item'] !== "undefined") {
    
      //if ( !item.properties ) {
      //  if (typeof item.properties == 'undefined') { 
      var qtyMaxAttr = "";
      if(productProperty=='free-product'){
        qtyMaxAttr = "max='2'";
      }
      var productQuantity = '<div class="ajax-cart-item__quantity">' + item.quantity + '</div>';
      var productQuantity = '<div class="ajax-cart-item__quantity"><quantity-input class="quantity" data-line="' + Number(index + 1) + '">'+
          '<button class="quantity__button no-js-hidden js-ajax-cart-minus" name="minus" type="button" aria-label="Increase quantity"><svg xmlns="http://www.w3.org/2000/svg" width="11.616" height="1.872" viewBox="0 0 11.616 1.872"><path id="Path_78" data-name="Path 78" d="M6.456-7.08H1.584v1.872H13.2V-7.08H6.456Z" transform="translate(-1.584 7.08)" fill="#63666a"/></svg></button>'+
          '<input class="quantity__input js-ajax-item__quantity" '+ qtyMaxAttr +' type="number" name="updates[]" id="Quantity-'+index+'" value="'+item.quantity+'" form="ajax-cart-item__quantity'+index+'">'+
          '<button class="quantity__button no-js-hidden js-ajax-cart-plus" name="plus" type="button" aria-label="Reduce quantity"><svg xmlns="http://www.w3.org/2000/svg" width="11.616" height="11.616" viewBox="0 0 11.616 11.616"><path id="Path_77" data-name="Path 77" d="M6.456-11.952V-7.08H1.584v1.872H6.456V-.336H8.328V-5.208H13.2V-7.08H8.328v-4.872Z" transform="translate(-1.584 11.952)" fill="#63666a"/></svg></button></div>'+
          '</quantity-input>';

    const productRemove = '<div data-vid="'+ item.variant_id +'" class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '" data-line="' + Number(index + 1) + '"><svg xmlns="http://www.w3.org/2000/svg" width="24.092" height="24.092" viewBox="0 0 24.092 24.092"><g id="Group_526" data-name="Group 526" transform="translate(-1.81 -1.81)"><path id="Path_91" data-name="Path 91" d="M21.818,15.286l-6.532,6.532" transform="translate(-4.695 -4.695)" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/><g id="Group_525" data-name="Group 525"><path id="Path_90" data-name="Path 90" d="M14.88,26.426A11.546,11.546,0,1,0,3.333,14.88,11.546,11.546,0,0,0,14.88,26.426Z" transform="translate(-1.023 -1.023)" fill="none" stroke="#63666a" stroke-linejoin="round" stroke-width="1"/><path id="Path_92" data-name="Path 92" d="M15.286,15.286l6.532,6.532" transform="translate(-4.695 -4.695)" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/></g></g></svg></div>';

    const concatProductInfo = '<div class="ajax-cart-item__single '+productProperty+'" data-variant-title="'+ item.variant_title +'" data-quantity="'+ item.quantity +'" data-product-id="'+ item.product_id +'" data-variant-id="'+ item.variant_id +'" data-id="'+ item.id +'" id="pro_'+ item.id + '" data-line="' + Number(index + 1) + '"><div class="ajax_pro_img">' + productImage +'</div><div class="ajax_pro_info"><div class="ajax_cart_info">'+ productTitle +  variantTitle + productSellingPlan + '</div><div class="ajax_cart_property"></div><div class="ajax_pro_btm"><div class="ajax_pro_left">' + productQuantity + productRemove +'</div><div class="ajax_pro_right">' + productPrice + '</div></div></div></div>';
  
    cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;

    $('.ajax-cart-related_product ul li').each(function(){
      var ProductID = $(this).data('product-id');
      if(item.id == ProductID){
        var ProductQuantity = $('.ajax-cart-item__single[data-id="'+item.id+'"]').data('quantity');
        if($(this).find('.product-form__buttons button').text() == 'Added'){
          $(this).find('.product-form__buttons button').text('Added('+ProductQuantity+')');
        }
      }
    });

    removeFromCart = document.querySelectorAll(defaults.removeFromCart);
    updateCart = document.querySelectorAll('.js-ajax-item__quantity');

    for (let i = 0; i < removeFromCart.length; i++) {
      removeFromCart[i].addEventListener('click', function() {
        const line = this.getAttribute('data-vid');
        var product_line = $('#pro_40572742598864').attr('data-vid');
        setTimeout(function () {
          if(product_line == line){
            $('#60-day-money-back-guarantee-5').prop('checked', false);
          }
        }, 1000);
        var variantId = $(this).data("vid");
        changeItem(variantId,0);
        changeItem(line);
      });
    }



    for (let i = 0; i < updateCart.length; i++) {
      updateCart[i].addEventListener('change', function() {
        const line = this.parentNode.getAttribute('data-line');
        const val = this.value;
        updateItem(line, val);
      });
    }

    if(item.final_price > 0){
      count++;
    }
  });
}


function openCartDrawer() {
  cartDrawer.classList.add('is-open');
  document.querySelector('body').classList.add('cart-drawer-open');
}

function closeCartDrawer() {
  cartDrawer.classList.remove('is-open');
  document.querySelector('body').classList.remove('cart-drawer-open');
}

function clearCartDrawer() {
  cartDrawerContent.innerHTML = '';
}

function openCartOverlay() {
  cartOverlay.classList.add('is-open');
  htmlSelector.classList.add('is-locked');
}

function closeCartOverlay() {
  cartOverlay.classList.remove('is-open');
  htmlSelector.classList.remove('is-locked');
}

function updateCartNote(){
  var note = $('.Cart__Note').val();

  $.ajax({
    url: '/cart/update.js',
    type: 'POST',
    dataType:"json",
    data: {note: note},
    success: function(result) {
      if(result.note != ''){
        $('.save-cart-note-button, .toggle-cart-note, .Cart__NoteButton').text('Edit Order Note');
      }else{
        $('.save-cart-note-button, .toggle-cart-note, .Cart__NoteButton').text('Add Order Note');
      }
    },
    error: function(jqxhr, status, exception) {}
  });

}

$('.toggle-cart-note').on('click', function(){
  $('.ajax-cart-drawer__buttons').toggleClass('active-note');
  $('.Cart__OffscreenNoteContainer').toggleClass('active');
});

if(cartNoteSubmit != undefined){
  cartNoteSubmit.addEventListener('click', function() {
    updateCartNote();
  });
} 


cartDrawerClose.addEventListener('click', function() {
  closeCartDrawer();
  closeCartOverlay();
});
// cart is empty stanje
cartOverlay.addEventListener('click', function() {
  closeCartDrawer();
  closeCartOverlay();
});

// cartDrawerTrigger.addEventListener('click', function(event) {
//   event.preventDefault();
//   openCartDrawer();
//   openCartOverlay();
// });

document.addEventListener('DOMContentLoaded', function() {
  fetchCart();
});



//Shopify.AjaxCartButtonQuerySelector = '.js-ajax-cart-drawer-trigger'; 

const slider = document.querySelector('.free-product-slider');
let isDown = false;
let startX;
let scrollLeft;

slider.addEventListener('mousedown', (e) => {
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});
slider.addEventListener('mouseleave', () => {
                        isDown = false;
                        slider.classList.remove('active');
});
slider.addEventListener('mouseup', () => {
                        isDown = false;
                        slider.classList.remove('active');
});
slider.addEventListener('mousemove', (e) => {
  if(!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 2; //scroll-fast
  slider.scrollLeft = scrollLeft - walk;
});


const slider1 = document.querySelector('.upsell-product-slider');
let isDown1 = false;
let startX1;
let scrollLeft1;

slider1.addEventListener('mousedown', (e) => {
  isDown1 = true;
  slider1.classList.add('active');
  startX1 = e.pageX - slider1.offsetLeft;
  scrollLeft1 = slider1.scrollLeft;
});
slider1.addEventListener('mouseleave', () => {
                         isDown1 = false;
                         slider1.classList.remove('active');
});
slider1.addEventListener('mouseup', () => {
                         isDown1 = false;
                         slider1.classList.remove('active');
});
slider1.addEventListener('mousemove', (e) => {
  if(!isDown1) return;
  e.preventDefault();
  const x1 = e.pageX - slider1.offsetLeft;
  const walk1 = (x1 - startX1) * 2; //scroll-fast
  slider1.scrollLeft = scrollLeft1 - walk1;
});